export default "__VITE_ASSET__Baeiyy3b__"